<template>
  <div
    class="card_buy_way"
    :style="isActive ? 'border: 1px solid #62d0e0;' : ''"
    @click="cilckItem(id)"
  >
    <div class="imgStyle">
      <svg class="icon-mpai-colors iconStyle" aria-hidden="true">
        <use :xlink:href="item.icon" />
      </svg>
    </div>
    <div class="text">{{ item.name }}</div>
    <div class="svgStyle" :style="isActive ? '' : 'display: none;'">
      <i class="icon-mpai-select iconStyle"></i>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    item: {
      type: Object,
      default: function() {
        return {};
      }
    },
    isActive: {
      type: Boolean,
      default: false
    },
    cilckItem: {
      type: Function,
      default: function(id) {}
    },
    id: {
      type: Number,
      default: 0
    }
  }
};
</script>

<style lang="less" scoped>
.card_buy_way:hover {
  border: 1px solid #62d0e0;
  background: #ecf5ff;
}
.card_buy_way {
  cursor: pointer;
  margin: 5px 10px;
  padding: 5px 10px;
  padding-left: 7px;
  border: 1px solid #d6f1f5;
  border-radius: 3px;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 32px;
  width: 94px;
  .imgStyle {
    max-height: 20px;
    .iconStyle {
      font-size: 24px;
      margin-right: 5px;
      // height: 100%;
      // width: 24px !important;
    }
  }
  .text {
    font-size: 14px;
  }
  .svgStyle {
    width: 14px;
    height: 14px;
    border-radius: 100% 0 0 0;
    background: #62d0e0;
    position: absolute;
    z-index: 0;
    margin-top: 17px;
    margin-left: 82px;
    display: flex;
    justify-content: center;
    align-items: center;
    .iconStyle {
      font-size: 12px;
      color: white;
      margin-left: 2px;
      margin-top: 4px;
    }
  }
}
</style>
